import moment from 'moment';
import * as mockLib from '../lib';
import dayjs from 'dayjs';

export default ({ start, end, granularity, category }) => {
  const vendor = 'aws';
  start = dayjs()
    .startOf('month')
    .format('YYYY-MM-DD');
  end = dayjs()
    .subtract(1, 'day')
    .format('YYYY-MM-DD');

  const broken = false;

  const categoryType = type => {
    switch (type) {
      case 'service':
        return awsServices;
      case 'account':
        return accounts;
    }
  };

  const formatGranularity = () => {
    switch (granularity) {
      case 'monthly':
        return 'months';
      case 'daily':
        return 'days';
      default:
        return granularity;
    }
  };

  const itemLength = category === 'service' ? 20 : 10;
  const valueName = ['true_unblended_cost', 'unblended_cost', 'blended_cost'];
  const dateFormat = formatGranularity() === 'days' ? 'YYYY-MM-DD' : 'YYYY-MM';
  const labelName = 'date';

  let minValue = 50;

  const term = moment(end).diff(start, formatGranularity());

  let data = [];

  for (let i = 0; i < itemLength; i++) {
    const resourceData = categoryType(category)[i];
    const date = [];
    let value = minValue;

    for (let i = 0; i <= term; i++) {
      // Broken mode
      if (broken && i % 9 === 0) continue;

      const newObj = {};
      // Date
      const d = moment(start)
        .add(i, formatGranularity())
        .format(dateFormat);

      newObj[labelName] = d;

      // Value
      //const times = resourceData === 'TOTAL' ? 100 : 10;

      for (const name of valueName) {
        value += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
        //value += Math.round(Math.random() * 100);
        //value += Math.random();

        newObj[name] = value;

        // Broken mode
        if (broken && i % 10 === 0) newObj[name] = `${value}`;
      }

      date.push(newObj);
    }

    const id = category === 'service' ? resourceData : mockLib.id();

    data.push({
      date: date,
      id: id,
      name: resourceData,
    });
  }

  const result = {};
  result[vendor] = data;

  return result;
};

export const awsServices = [
  //'TOTAL',
  'AmazonEC2',
  'AWSLambda',
  'AmazonCloudFront',
  'AWSCloudTrail',
  'AmazonCloudWatch',
  'AWSConfig',
  'AWSDataTransfer',
  'AWSDirectoryService',
  'AmazonDynamoDB',
  'AmazonECR',
  'AmazonElastiCache',
  'AmazonES',
  'awskms',
  'AmazonKinesis',
  'AmazonRDS',
  'AmazonRekognition',
  'AmazonRedshift',
  'AmazonRoute53',
  'AmazonSES',
  'AmazonSNS',
  'AWSQueueService',
  'AmazonS3',
  'AmazonSimpleDB',
  'AWSSupportDeveloper',
  'AmazonVPC',
  'awswaf',
];

export const accounts = [
  'Alphaus Labs',
  'Alphaus Login',
  'Alphaus ScanMonster',
  'Alphaus estimating-tool',
  'Alphaus Billing (Japan)',
  'Alphaus Next',
  'Alphaus Security',
  'Alphaus Ripple Production',
  'Alphaus Docomo',
  'Alphaus Route53',
];
